import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';

import { fetchFundingPaymentsPaginated } from '#/api/apiExchange';
import { getPaginationPerPageLimit } from '#/config/configUtils';
import { PAGINATION_PAGES_LIMIT } from '#/config/constants';

import { minutes, seconds } from './utils';

export const PAGE_LIMIT = getPaginationPerPageLimit(50);

/** https://tanstack.com/query/v4/docs/react/guides/paginated-queries */
export const useFundingPaymentsPaginatedQuery = ({
  walletAddress,
  isVault,
  page,
  filterMarket,
}: {
  walletAddress: string;
  isVault: boolean;
  page: number;
  filterMarket?: string;
}) => {
  return useQuery({
    queryKey: [
      'fundingPaymentsPaginated',
      walletAddress,
      isVault,
      filterMarket || 'all-markets',
      page,
    ],

    queryFn:
      !walletAddress || page > PAGINATION_PAGES_LIMIT
        ? skipToken
        : async () => {
            const result = await fetchFundingPaymentsPaginated({
              walletAddress,
              isVault,
              page,
              pageLimit: PAGE_LIMIT,
              market: filterMarket,
            });
            return {
              count: result.count,
              items: result.items.reverse(),
            };
          },
    staleTime: seconds(10),
    refetchOnWindowFocus: false,
    refetchInterval: minutes(7),
    // We have to keep previous data for better
    // UX  on pagination (switching pages)
    placeholderData: keepPreviousData,
  });
};
